module.exports = __webpack_public_path__ + "static/media/checked.6ef2b847.svg";